import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractProblemApiService } from '../abstract/abstract-problem-api-service';
import { ProblemModel } from 'src/app/store/problem/model';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';

const baseUrl = `/api/problems`;

@Injectable()
export class ProblemApiService extends AbstractProblemApiService {
  private http = inject(HttpClient);

  getProblems(): Observable<InteractorResponse<ProblemModel[]>> {
    return this.http.get<InteractorResponse<ProblemModel[]>>(`${baseUrl}`);
  }

  getProblemById(id: number): Observable<InteractorResponse<ProblemModel>> {
    return this.http.get<InteractorResponse<ProblemModel>>(`${baseUrl}/${id}`);
  }

  saveProblem(problem: ProblemModel): Observable<InteractorResponse<ProblemModel>> {
    return this.http.put<InteractorResponse<ProblemModel>>(`${baseUrl}`, problem);
  }

  createProblem(problem: ProblemModel): Observable<InteractorResponse<ProblemModel>> {
    return this.http.post<InteractorResponse<ProblemModel>>(`${baseUrl}`, problem);
  }

  deleteProblem(id: number): Observable<InteractorResponse<null>> {
    return this.http.delete<InteractorResponse<null>>(`${baseUrl}/${id}`);
  }

  solvedProblem(id: number): Observable<InteractorResponse<ProblemModel>> {
    return this.http.put<InteractorResponse<ProblemModel>>(`${baseUrl}/${id}/solved`, null);
  }
}
